import React from "react";
import { NavLink } from "react-router-dom";

import { ReactComponent as StarIcon } from "@assets/images/icons/star.svg";
import { ReactComponent as CheckIcon } from "@assets/images/icons/check-blue.svg";
import { ReactComponent as MedalIcon } from "@assets/images/icons/medal-gold.svg";
import { ReactComponent as TrendIcon } from "@assets/images/icons/arrow-up-green.svg";

import "./TraderOverview.sass";

export const TraderOverview = ({ trader }) => {
  if (!trader) return null;

  return (
    <div className="trader-overview">
      {/* 1. Breadcrumbs */}
      <div className="trader-overview__breadcrumbs">
        <NavLink to="/copytrade">Copytrading</NavLink>

        <span>/</span>

        <span className="trader-overview__breadcrumbs-current">
          {trader.name}
        </span>
      </div>

      <div className="trader-overview__content">
        {/* 2. Main Profile Info */}
        <div className="trader-overview__profile">
          <img
            src={trader.avatar}
            alt={trader.name}
            className="trader-overview__avatar"
          />

          <div className="trader-overview__details">
            <h1 className="trader-overview__name">{trader.name}</h1>

            <div className="trader-overview__badges">
              <div className="trader-overview__badge trader-overview__badge--blue">
                <CheckIcon /> Verified
              </div>

              <div className="trader-overview__badge trader-overview__badge--gold">
                <MedalIcon /> Top Performer
              </div>

              <div className="trader-overview__badge trader-overview__badge--green">
                <TrendIcon /> Long-bias
              </div>
            </div>
          </div>
        </div>

        {/* 3. Action Buttons */}
        <div className="trader-overview__actions">
          <button className="trader-overview__star-btn">
            <StarIcon />
          </button>

          <button className="trader-overview__btn trader-overview__btn--dark">
            Subscribe
          </button>

          <button className="trader-overview__btn trader-overview__btn--orange">
            Copy
          </button>
        </div>
      </div>

      {/* 4. Bottom Stats Row */}
      <div className="trader-overview__stats">
        {trader.stats?.map((stat, index) => (
          <React.Fragment key={index}>
            <div className="trader-overview__stat-item">
              <span className="trader-overview__stat-label">{stat.label}</span>

              <span className="trader-overview__stat-value">{stat.value}</span>
            </div>

            {index < trader.stats.length - 1 && (
              <div className="trader-overview__stat-divider"></div>
            )}
          </React.Fragment>
        ))}
      </div>
    </div>
  );
};
